import compact from 'lodash/compact';

export const compactCommaSeparatedString = (rawInput: string): string[] =>
  compact(rawInput.split(',').map(_string => _string.trim()));
